import React from 'react';

const JoinTheClub: React.FC = () => {
  return (
    <section className="mx-auto px-4 md:px-10 lg:px-32 w-full bg-[#192842] pt-20 pb-20">
      <div className="">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          {/* Text Content - Left Side */}
          <div className="space-y-8">
            <h2 className="text-[30px] md:text-[40px] lg:text-[48px] font-[700] leading-[40px] text-[#fff] mb-7 lg:text-left">
              Join The Club
            </h2>
            <p className="text-[16px] md:text-[20px] lg:text-[20px] text-[#fff] leading-[29px] font-[400] mb-4 last:mb-0">
            Ready to transform your portfolio? The Wealthy Miner is your insider edge in the junior mining stocks. Subscribe today and get instant access to Robert’s latest stock picks. exclusive research, and a community built for wealth creation. Don’t miss the next 10x opportunity—join now and start stacking the odds for success.</p>
                         <a href="https://the-wealthy-miner.mn.co/" target="_blank" rel="noopener noreferrer" className="inline-block w-full sm:w-auto bg-transparent border-2 border-white text-[#fff] px-32 py-2.5 rounded-lg font-semibold text-lg hover:bg-white hover:text-[#1A2A44] transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50 text-center">
              JOIN US
            </a>
          </div>

          {/* Phone Mockups - Right Side */}
          <div className="flex justify-center lg:justify-end">
            <img 
              src="/images/phones.webp" 
              alt="Three overlapping phone mockups showing The Wealthy Miner app content" 
              className="w-full max-w-4xl h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinTheClub;
